

import { useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../jsx/axiosClient";

export function IslFileUploadHandler(userSession,activeSection) {
  const MySwal = withReactContent(Swal);

  // Media states
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(false);
const [isGenerating, setIsGenerating] = useState(false);

  // Common fields
  const [mediaTitle, setMediaTitle] = useState("");
  const [mediaTitleError, setMediaTitleError] = useState(false);
  const [mediaDescription, setMediaDescription] = useState("");
  const [mediaDescriptionError, setMediaDescriptionError] = useState(false);
  const [mediaNarrator, setMediaNarrator] = useState("m1");
  const [mediaLanguage, setMediaLanguage] = useState("en-US");
  const [mediaDescriptionType, setMediaDescriptionType] = useState("Brief");
  const [mediaVoice, setMediaVoice] = useState("Male");
  const [mediaFormats, setMediaFormats] = useState(["video"]);
  const [mediaFormatError, setMediaFormatError] = useState(false);

  // YouTube
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [youtubeUrlError, setYoutubeUrlError] = useState(false);
 const [ytTitle, setYtTitle] = useState("");
  const [ytTitleError, setYtTitleError] = useState(false);
  const [ytDescription, setYtDescription] = useState("");
  const [ytDescriptionError, setYtDescriptionError] = useState(false);
    const [ytNarrator, setYtNarrator] = useState("m1");

  // Drag/drop
  const [dragging, setDragging] = useState(false);

  // Format options
  const formats = [
    { label: "Text", value: "text" },
    { label: "Audio", value: "audio" },
    { label: "Video", value: "video" },
  ];

  // Toggle format
  const toggleFormat = (value) => {
    if (value === "video") return;
    setMediaFormats((prev) => {
      let updated;
      if (prev.includes(value)) {
        updated = prev.filter((f) => f !== value);
      } else {
        updated = [...prev, value];
      }
      if (!updated.includes("video")) updated.push("video");
      setMediaFormatError(updated.length === 0);
      return updated;
    });
  };

  // File handling
  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
      setFileError(false);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
      setFileError(false);
    }
  };

  // Unified auto-detect submit
  const handleSubmit = async () => {
    console.log("IslFileUploadHandler handlesubmit")
        setFileError(false);
setYoutubeUrlError(false);
setMediaTitleError(false);
    setIsGenerating(true);
    let valid = true;
    const formData = new FormData();
const isYouTube = activeSection === "youtube";
const isMedia = activeSection === "media";

   if (!isYouTube && !isMedia) {
      console.log("!isYouTube && !isMedia")
    setFileError(true);
    setYoutubeUrlError(true);
    valid = false;
     return;
    }
    if (isMedia) {
        formData.delete("youtube_url");

      if (!file) {
        setFileError(true);
        valid = false;
      }
      // Title is hidden — skip validation
      if (!valid) return;

      formData.append("file", file);
    }

 if (isYouTube) {
        formData.delete("file");

      if (!youtubeUrl.trim()) {
        setYoutubeUrlError(true);
        valid = false;
      }
      // Title is hidden — skip validation
   
      if (!valid) return;

      formData.append("youtube_url", youtubeUrl);
    }
  

    formData.append("title", mediaTitle || "ISL Video");
    formData.append("description", mediaTitle || "ISL Video");
    formData.append("narrator", mediaNarrator);
        console.log("FormData contents:");
        for (let [key, val] of formData.entries()) {
            console.log(key, val);
        }
    try {
      MySwal.fire({
        title: "Uploading...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => MySwal.showLoading(),
      });

      const response = await api.post("/convert-isl-file", formData, {
        headers: {
          Authorization: `Bearer ${userSession.access_token}`,
        },
        withCredentials: true,
      });

      const result = response.data;
      MySwal.close();

      if (result.status === "success") {
        await MySwal.fire({
          icon: "success",
          title: "Upload Successful",
          text:
            result.message ,
          confirmButtonText: "OK",
        });
        window.location.reload();
      } else {
        MySwal.fire({
          icon: "error",
          title: "Upload Failed",
          text:
            result.message || "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      MySwal.fire({
        icon: "error",
        title: "Server Error",
        text:
          error.response?.data?.message ||
          "Could not connect to backend. Please try again later.",
      });
    }
  };


 const handleYoutubeISLSubmit = async () => {
      console.log("handleYoutubeSubmit fn IslFileUploadHandler")
 setIsGenerating(true);
    let valid = true;
    const formData = new FormData();
          formData.append("youtube_url", youtubeUrl);
    formData.append("title", ytTitle || "ISL Video");
    formData.append("description", ytTitle || "ISL Video");
    formData.append("narrator", ytNarrator);
        console.log("FormData ISL contents:");
        for (let [key, val] of formData.entries()) {
            console.log(key, val);
        }
    try {
      MySwal.fire({
        title: "Uploading...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => MySwal.showLoading(),
      });

      const response = await api.post("/convert-isl-file", formData, {
        headers: {
          Authorization: `Bearer ${userSession.access_token}`,
        },
        withCredentials: true,
      });

      const result = response.data;
      MySwal.close();

      if (result.status === "success") {
        await MySwal.fire({
          icon: "success",
          title: "Upload Successful",
          text:
            result.message ,
          confirmButtonText: "OK",
        });
        window.location.reload();
      } else {
        MySwal.fire({
          icon: "error",
          title: "Upload Failed",
          text:
            result.message || "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      MySwal.fire({
        icon: "error",
        title: "Server Error",
        text:
          error.response?.data?.message ||
          "Could not connect to backend. Please try again later.",
      });
    }
  };


  return {
    // state vars
    file,
    fileError,
    mediaTitle,
    mediaTitleError,
    mediaDescription,
    mediaDescriptionError,
    mediaNarrator,
    mediaLanguage,
    mediaDescriptionType,
    mediaVoice,
    mediaFormats,
    mediaFormatError,
    youtubeUrl,
    youtubeUrlError,
    dragging,
    formats,
    ytTitle,
    ytTitleError,
    ytDescription,
    ytDescriptionError,
    ytNarrator,
    // setters
    setFile,
    setFileError,
    setMediaTitle,
    setMediaDescription,
    setMediaNarrator,
    setMediaLanguage,
    setMediaDescriptionType,
    setMediaVoice,
    setMediaFormats,
    setMediaFormatError,
    setMediaTitleError,
    setMediaDescriptionError,
    setYoutubeUrl,
    setYoutubeUrlError,
    setDragging,
    setYtTitle,
    setYtTitleError,
    setYtDescription,
    setYtDescriptionError,
    setYtNarrator,
    // handlers
    toggleFormat,
    handleDrop,
    handleFileChange,
    handleSubmit,
    handleYoutubeISLSubmit,
  };
}
